import { h } from 'preact';
import { iterable } from '@utils/misc';
import CategoryBox from '@ui/Archive/CategoryBox';

export default function CategoryList({ categories, showTitle }) {
    return (
        <div className="subCategories">
            {showTitle && (<span className="subCategories__title">
                Relaterade kategorier
            </span>)}

            {iterable(categories) && (
                <ul className="subCategories__list">
                    {categories.map(category => (<CategoryBox
                        key={category.seName ?? category.url}
                        category={category}
                        showDescription={false}
                    />))}
                </ul>
            )}
        </div>
    )
}